/*
 * Floating-widget guard.
 *
 * The WhatsApp bubble is fixed at bottom-right with the maximum z-index, so on a
 * phone it lands squarely on the right-hand column's Add to Cart button as the
 * product rows scroll past. It cannot be layered under them: it sits outside the
 * sections' stacking contexts, so no z-index on a card can win.
 *
 * So it yields instead. While a real call to action is underneath it, the bubble
 * fades back and stops taking pointer events; the moment the CTA scrolls clear
 * it returns. It is never removed, its own styling is untouched, and no product
 * button is narrowed to make room.
 *
 * Everything is measured from live rects rather than assumed offsets, so it
 * holds at any width and with the bubble on either side.
 */
(function () {
  'use strict';

  /* lts2-head renders once per section, so this file arrives in several script
     tags on one page. The browser caches the fetch but executes each tag, and
     each execution would register its own listeners - nine delegated click
     handlers and nine dialogs. First one in wins; the rest return. */
  if (window.__lts2WidgetGuardReady) return;
  window.__lts2WidgetGuardReady = true;

  var WIDGET = '#chat-bubble, .whatsapp-widget';
  /* The controls worth protecting: card buttons and the section-level buttons. */
  var CTAS = '.lts2-pcard__atc .button-ATC, .lts2-new__more .lts2-btn, .lts2-cats__more .lts2-btn, .lts2-cta .lts2-btn';
  var PAD = 8;          // treat a near miss as a hit
  var widget = null;
  var raf = 0;

  function overlaps(a, b) {
    return !(a.right < b.left - PAD || a.left > b.right + PAD ||
             a.bottom < b.top - PAD || a.top > b.bottom + PAD);
  }

  function check() {
    raf = 0;
    if (!widget) return;
    /* An open localization sheet or quick-add already hides the bubble; leave
       that alone rather than fighting over the same class. */
    if (document.body.classList.contains('lts-lang-locked') ||
        document.body.classList.contains('lts2-qa-locked')) return;

    var w = widget.getBoundingClientRect();
    if (!w.width) return;

    var hit = false;
    var ctas = document.querySelectorAll(CTAS);
    for (var i = 0; i < ctas.length; i++) {
      var r = ctas[i].getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) continue;   // off-screen
      if (overlaps(w, r)) { hit = true; break; }
    }
    widget.classList.toggle('lts2-widget-yield', hit);
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(check);
  }

  function start() {
    widget = document.querySelector(WIDGET);
    if (!widget) return;
    check();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
  }

  /* The widget is injected by an app, so it may not exist at DOMContentLoaded.
     Watch for it, then stop watching once found. */
  function init() {
    start();
    if (widget || !window.MutationObserver) return;
    var mo = new MutationObserver(function () {
      start();
      if (widget) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
